import { render, staticRenderFns } from "./MotivoDespesaList.vue?vue&type=template&id=5d30f633&scoped=true"
import script from "./MotivoDespesaList.vue?vue&type=script&lang=js"
export * from "./MotivoDespesaList.vue?vue&type=script&lang=js"
import style0 from "./MotivoDespesaList.vue?vue&type=style&index=0&id=5d30f633&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d30f633",
  null
  
)

export default component.exports